import type { RefObject } from "react";
import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { sortMembershipProductsForHome } from "../spacePageUtils";
import { SpaceHomeMembershipListItem } from "./SpaceHomeMembershipListItem";

/** 订阅卡片列表 */
export function SpaceHomeSubscribeCards(props: {
  spaceId: string;
  products: MembershipProduct[];
  isLoggedIn: boolean;
  spaceProfile: SpaceProfile | null;
  listRef: RefObject<HTMLUListElement>;
  onLoginRequest: () => void;
}): JSX.Element | null {
  const { spaceId, products, isLoggedIn, spaceProfile, listRef, onLoginRequest } = props;
  const sortedProducts = sortMembershipProductsForHome(products);
  if (sortedProducts.length === 0) {
    return null;
  }
  return (
    <section className="space-home-feed__section space-home-subscribe-section" aria-label="权益订阅">
      <p className="space-home-feed__section-hint">权益订阅</p>
      <ul
        ref={listRef}
        id="space-home-membership-list"
        className="space-membership-list"
        aria-label="会员产品列表"
      >
        {sortedProducts.map((row) => (
          <SpaceHomeMembershipListItem
            key={row.spaceProductId}
            spaceId={spaceId}
            row={row}
            isLoggedIn={isLoggedIn}
            onLoginRequest={onLoginRequest}
            spaceProfile={spaceProfile}
          />
        ))}
      </ul>
    </section>
  );
}
